import React from 'react';
import { Route, IndexRoute } from 'react-router';

// Containers
import App from './containers/App';
// import MainApp from './containers/MainApp';

import Profile from './containers/Profile';

import PatientIndex from './containers/Patients';
import PatientEdit from './containers/PatientEdit';
import NewPatient from './components/patient/NewPatient';

import Charting from './containers/Charting';

import ManagementIndex from './containers/Management';
import AccountingIndex from './containers/Accounting'
import Procedures from './containers/Procedures';
import Accounts from './containers/Accounts';
import Clinics from './containers/Clinics';
import InventoryIndex from './containers/Inventory';
import PrescriptionTemplates from './containers/PrescriptionTemplates';
import Settings from './containers/Settings';
import SMSManager from './containers/SMSManager';

// New Containers
import Home from './containers/Home';
import Login from './containers/Login';

export default (
    <Route path="/">
        <IndexRoute component={Login} />

        <Route path="/home" component={App}>
            <IndexRoute component={Home} />
        </Route>

        <Route path="/user" component={App}>
            <IndexRoute component={Profile} />
        </Route>

        <Route path="/patients" component={App}>
            <IndexRoute component={PatientIndex} />
            <Route path="new_patient" component={NewPatient}/>
            <Route path="charting" component={Charting}/>
            <Route path=":patientId" component={PatientEdit}/>
        </Route>

        <Route path="management" component={App}>
            <IndexRoute component={ManagementIndex} />

            <Route path="accounting" component={AccountingIndex} />
            <Route path="procedures" component={Procedures} />
            <Route path="accounts" component={Accounts} />
            <Route path="clinics" component={Clinics} />
            <Route path="inventory" component={InventoryIndex} />
            <Route path="prescriptions" component={PrescriptionTemplates} />
            <Route path="settings" component={Settings} />
            <Route path="sms-manager" component={SMSManager} />
        </Route>
    </Route>
)



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/